module.exports = __webpack_public_path__ + "img/ceramic-yellow.1cb4bc34.png";